<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-row v-bind:class="[{ busy: busy}]" class="opacity-transition">
        <b-col>
            <ImageInput @input="imageSelected" :inline="true" :value="localTile.image" id="img-select" label="Bild"
                        name="img-select"/>
            <b-row>
                <b-col cols="6">
                    <div v-if="localTile.image" class="pin-img-stage" @drop="drop" @dragover="dragover"
                         @dragenter="dragenter">
                        <img @click="addPin" :src="fileResourceUrl(localTile.image)" alt="Pin Image"/>
                        <div @click="selectPin(pin)" v-bind:key="index" v-for="(pin,index) in localTile.pinList"
                             draggable="true" @dragstart="dragstart($event, index)" class="pin-container"
                             :style="{ top: pin.y + '%', left: pin.x + '%' }">
                            <div class="pin">
                                <i class="fal fa-plus"></i>
                            </div>

                            <div v-if="selectedPin === pin" class="pin-info">
                                <b-button variant="link" size="sm" @click.stop="removePin(selectedPin)">
                                    <i class="fal fa-trash-alt"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6" v-if="selectedPin">
                    <b-form>
                        <b-form-group label="Type">
                            <b-form-radio-group id="radio-group-2" v-model="selectedPin.type"
                                                name="radio-sub-component">
                                <b-form-radio value="article">Article</b-form-radio>
                                <b-form-radio value="image">Image</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                        <div v-if="selectedPin.type === 'image'">
                            <ImageInput @input="selectImage" :inline="true" label="Bild" name="img-select"/>
                            <draggable v-model="selectedPin.imageList">
                                <transition-group>
                                    <b-list-group-item :key="element" v-for="(element, key) in selectedPin.imageList">
                                        <b-row>
                                            <b-col cols="2"><img class="thumbnail" width="100%"
                                                                 :src="fileResourceUrl(element)"/></b-col>
                                            <b-col cols="2">
                                                <b-button variant="link" @click="removeImage(element)">
                                                    <i class="fal fa-trash-alt"></i>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-list-group-item>
                                </transition-group>
                            </draggable>
                        </div>
                        <div v-else>
                            <b-form-group
                                    label="Artikel:"
                                    label-for="selectArticle">
                                <v-select
                                        :filter="filterArticles"
                                        @input="loadArticleDetails"
                                        id="selectArticle"
                                        :searchable="true"
                                        v-model="selectedArticleStub"
                                        :getOptionKey="(option) => option.id"
                                        label="primaryDescription"
                                        :options="articleList">
                                    <template v-slot:option="option">
                                        <img class="thumbnail" style="max-width: 40px;"
                                             :src="imageResource((option.webImage || option.image), 50)"/>

                                        <span class="ml-2">{{option.name}} | {{option.primaryDescription || option.secondaryDescription}} | {{option.colorId}}<i
                                                v-if="selectedPin.articleList.find(i => {return (i.id === option.id && i.colorId === option.colorId)})"
                                                style="float:right;margin:auto;" class="fa fa-check"
                                                aria-hidden="true"></i></span>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <img class="thumbnail" style="max-width: 40px;"
                                             :src="imageResource((option.webImage || option.image), 50)"/>

                                        <span class="ml-2">{{option.name}} | {{option.primaryDescription || option.secondaryDescription}} | {{option.colorId}}<i
                                                v-if="selectedPin.articleList.find(i => {return (i.id === option.id && i.colorId === option.colorId)})"
                                                style="float:right;margin:auto;" class="fa fa-check"
                                                aria-hidden="true"></i></span>
                                    </template>
                                </v-select>
                            </b-form-group>
                            <b-form-group
                                    v-if="variantImages.length > 0"
                                    label="Artikel-Variante:"
                                    label-for="selectArticleVariant">
                                <v-select
                                        @input="selectVariant"
                                        id="selectArticleVariant"
                                        :searchable="true"
                                        :clearable="false"
                                        :getOptionKey="(option) => option.thumbnail + option.colorId"
                                        v-model="selectedVariant"
                                        :disabled="busy"
                                        :options="variantImages">
                                    <template v-slot:option="option">
                                        <img class="thumbnail" style="max-width: 40px;"
                                             :src="fileResourceUrl(option.thumbnail)"/>
                                        <span class="ml-2">{{option.label}}<i
                                                v-if="selectedPin.articleList.find(i => {return (i.id === option.id && i.colorId === option.colorId)})"
                                                style="float:right;" class="fa fa-check" aria-hidden="true"></i></span>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <img class="thumbnail" style="max-width: 40px;"
                                             :src="fileResourceUrl(option.thumbnail)"/>
                                        <span class="ml-2">{{option.label}}<i
                                                v-if="selectedPin.articleList.find(i => {return (i.id === option.id && i.colorId === option.colorId)})"
                                                style="float:right;" class="fa fa-check" aria-hidden="true"></i></span>
                                    </template>
                                </v-select>
                            </b-form-group>
                            <b-list-group>
                                <draggable v-model="selectedPin.articleList">
                                    <transition-group>
                                        <b-list-group-item :key="index + element.id"
                                                           v-for="(element,index) in selectedPin.articleList">
                                            <b-row>
                                                <b-col cols="2"><img class="thumbnail" width="100%"
                                                                     :src="fileResourceUrl(element.thumbnail)"/></b-col>
                                                <b-col> {{element.label}}<br>
                                                    <b-form-input :value="element.metaLabel" @input="changingInput(element, $event)"
                                                                  placeholder="Alternative name"></b-form-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <b-button variant="link" @click="removeVariant(element)">
                                                        <i class="fal fa-trash-alt"></i>
                                                    </b-button>
                                                </b-col>
                                            </b-row>
                                        </b-list-group-item>
                                    </transition-group>
                                </draggable>
                            </b-list-group>
                        </div>


                    </b-form>
                </b-col>
            </b-row>
        </b-col>
        <pb-spinner v-if="busy"></pb-spinner>
    </b-row>
</template>
<script>
    import ArticleApi from "../../../../../../shared/_api/article";
    import draggable from 'vuedraggable';
    import ImageInput from "../ImageInput";

    export default {
        props: {
            tile: Object,
            articleList: {
                type: Array,
                default: () => []
            },
            variantFunc: {
                type: Function,
                default: () => {
                    return []
                }
            }
        },
        components: {draggable, ImageInput},
        data() {
            return {
                busy: false,
                selectedPin: null,
                localTile: this.tile,
                selectedArticleFull: null,
                selectedArticleStub: null,
                selectedVariant: null
            }
        },
        methods: {
            changingInput(article, value) {
                article['metaLabel'] = value;
                if(!this.selectedPin.metaData) {
                    this.selectedPin.metaData = {};
                }
                if(!this.selectedPin.metaData.articleLabel) {
                    this.selectedPin.metaData.articleLabel = {};
                }
                this.selectedPin.metaData.articleLabel[article.id] = value;
            },
            filterArticles(options, filterProp) {
                if (!filterProp) {
                    return true;
                }

                let result = [],
                    searchString = filterProp.toLowerCase();

                for (let i = 0; i < options.length; i++) {
                    let option = options[i],
                        propArr = [],
                        label = (option.primaryDescription || option.secondaryDescription);


                    if (label) {
                        propArr.push(label.toLowerCase());
                    }

                    if (option.name) {
                        propArr.push(option.name.toLowerCase());
                    }

                    for (let i = 0; i < propArr.length; i++) {
                        if (propArr[i].indexOf(searchString) !== -1) {
                            result.push(option);
                        }
                    }
                }
                return this.$_.uniqBy(result, 'id');
            },
            loadArticleDetails(article) {
                this.busy = true;
                ArticleApi.customerArticleStubById(article.id, 1500).then(article => {
                    this.selectedArticleFull = article;
                }).finally(() => {
                    this.busy = false;
                });
            },
            selectVariant(article) {
                this.selectedPin.articleList.push(article);
            },
            removeVariant(article) {
                let index = this.selectedPin.articleList.indexOf(article);
                this.selectedPin.articleList.splice(index, 1);
            },
            selectImage(image) {
                if (!this.selectedPin.imageList) {
                    this.$set(this.selectedPin, "imageList", []);
                }
                this.selectedPin.imageList.push(image);
            },
            removeImage(image) {
                let index = this.selectedPin.imageList.indexOf(image);
                this.selectedPin.imageList.splice(index, 1);
            },
            imageSelected(img) {
                this.localTile.image = img;
            },
            dragstart(e, pinIndex) {
                e.dataTransfer.setData("text", pinIndex);
            },
            dragover(e) {
                e.preventDefault();
            },
            dragenter(e) {
                e.preventDefault();
            },
            drop(e) {
                e.preventDefault();
                let pinIndex = Number(e.dataTransfer.getData("text")),
                    bounds = e.target.getBoundingClientRect();

                this.localTile.pinList[pinIndex].x = (e.clientX - bounds.left) / bounds.width * 100;
                this.localTile.pinList[pinIndex].y = (e.clientY - bounds.top) / bounds.height * 100;

            },
            selectPin(pin) {
                this.selectedPin = pin;
                if(this.selectedPin.metaData && this.selectedPin.metaData.articleLabel) {
                    this.selectedPin.articleList.forEach(value => {
                        if(this.selectedPin.metaData.articleLabel[value.id]){
                            value.metaLabel = this.selectedPin.metaData.articleLabel[value.id];
                        }
                    });
                }
            },
            addPin($event) {
                let bounds = event.target.getBoundingClientRect();

                let pin = {
                    x: ($event.clientX - bounds.left) / bounds.width * 100,
                    y: ($event.clientY - bounds.top) / bounds.height * 100,
                    articleList: [],
                    imageList: [],
                    type: 'article',
                    metadata: []
                };

                this.selectedPin = pin;

                this.localTile.pinList.push(pin);
            },
            removePin(pin) {
                let index = this.localTile.pinList.indexOf(pin);
                this.localTile.pinList.splice(index, 1);
                this.selectedPin = null;
            },
            updatePin(pin) {
                var foundIndex = this.localTile.pinList.findIndex(x => x.x === pin.id);
                this.localTile.pinList[foundIndex] = pin;
            },
            resetArticleSelection() {
                this.selectedArticleFull = null;
                this.selectedArticleStub = null;
                this.selectedVariant = null;
            }
        },
        computed: {
            variantImages() {
                if (this.selectedArticleFull) {
                    return this.variantFunc(this.selectedArticleFull);
                }
                return [];
            },
        },
        watch: {
            localTile: {
                handler: function (value) {
                    this.$emit("update", value);
                },
                deep: true
            },
            selectedPin: {
                handler: function () {
                    this.resetArticleSelection();
                },
            }
        },
    }

</script>

<style lang="scss" scoped>
    .pin-img-stage {
        position: relative;
        display: inline-block;

        .pin-container {
            position: absolute;
        }

        .pin {
            cursor: pointer;
            width: 25px;
            height: 25px;
            background-color: white;
            border-radius: 50%;
            box-shadow: 0 2px 30px 0 #4A4B4D;
            text-align: center;
            z-index: 999;
        }

        .pin-info {
            color: white;
            position: absolute;
            top: -20px;
            left: 20px;

            button {
                color: white;
            }
        }

        img {
            max-width: 100%;
            display: block;
            margin: auto;
            object-fit: cover;
        }
    }

    .article-select {
        position: absolute;
    }


</style>
